import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { DialogConfirmComponent } from 'app/components/modal/dialog-confirm/dialog-confirm.component';
import { DialogConfirmType } from 'app/components/modal/dialog-confirm/dialog-confirm.model';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { AuthorizeService } from 'app/services/authorize/authorize.service';
import { CartService } from 'app/services/cart/cart.service';
import { CartModel } from '../../../model/cart.model';

@Component({
  selector: 'act-dialog-cart-summary',
  templateUrl: './dialog-cart-summary.component.html',
  styleUrls: ['./dialog-cart-summary.component.scss']
})
export class DialogCartSummaryComponent implements OnInit {
  data: {
    formatSearchDate: string,
    cart: CartModel,
    bookNight: number,
    multiPaymentDetail: any,
    grandTotalPrice: number,
    message,
    multiPaymentMainChannel,
    isAllowMultiCorporateFleetOnly
  };


  constructor(
    private translatePipe: TranslatePipe,
    private dialog: MdDialog,
    private authorizeService: AuthorizeService,
    private cartService: CartService
  ) { }

  ngOnInit() { }

  onCancelShareBudget() {
    const message = { text: this.translatePipe.transform('dialog-cancel-share-budget-text'), subText: this.translatePipe.transform('dialog-cancel-share-budget-sub-text') };
    const dialogRef: MdDialogRef<DialogConfirmComponent> = this.dialog.open(DialogConfirmComponent,
      {
        data: {
          confirmType: DialogConfirmType.CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
          data: {
            message: message
          }
        },
      });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.authorizeService.removeCoBookerCookie();
        this.cartService.updateCartCancelShareBudget();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cart/dialog-cart-summary/dialog-cart-summary.component.ts